export default __webpack_public_path__ + "locales/pl/SharingPanel.json?hash=80597b4eaf5af1fcd7741f41c8023edd";